require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-is-missing-from-world-bank-supported-interventions.json") })
        }
      }, "path---en-us-update-what-is-missing-from-world-bank-supported-interventions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-is-missing-from-world-bank-supported-interventions!./.cache/json/en-us-update-what-is-missing-from-world-bank-supported-interventions.json
// module id = 843
// module chunks = 231608221292675